import { type FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@monorepo/nova-ui';
import { OptionalAssets } from '@monorepo/types';
import { type CreditCartAsset } from '../credit-events.types';
import {
  StyledAssetSelectorMobileApplyButton,
  StyledAssetSelectorMobileHeader,
  StyledAssetSelectorMobileTitle,
  StyledNewOrderLink,
} from '../styled';
import { CreditAssetCards } from './credit-asset-cards';

interface CreditAssetSelectorMobileProps {
  cartAssets: CreditCartAsset[];
  onApply: (asset: OptionalAssets) => void;
  onNewOrder: () => void;
}

const CreditAssetSelectorMobile: FC<CreditAssetSelectorMobileProps> = ({
  cartAssets,
  onApply,
  onNewOrder,
}) => {
  const { t } = useTranslation(['creditEventsModal']);
  const [selected, setSelected] = useState<OptionalAssets>(
    cartAssets[0]?.asset,
  );

  return (
    <>
      <StyledAssetSelectorMobileHeader>
        <StyledAssetSelectorMobileTitle>
          {t('creditEventsModal:selector.title')}
        </StyledAssetSelectorMobileTitle>
        <StyledAssetSelectorMobileApplyButton
          variant="outlined"
          onClick={() => onApply(selected)}
        >
          {t('creditEventsModal:selector.apply_button')}
        </StyledAssetSelectorMobileApplyButton>
      </StyledAssetSelectorMobileHeader>

      <Stack padding={2} gap={1}>
        <CreditAssetCards
          cartAssets={cartAssets}
          selected={selected}
          onSelect={setSelected}
        />

        <StyledNewOrderLink onClick={onNewOrder}>
          {t('creditEventsModal:selector.new_order')}
        </StyledNewOrderLink>
      </Stack>
    </>
  );
};

export default CreditAssetSelectorMobile;
